import AppWrapper from 'AppWrapper';
import { apiClient } from 'api';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';

import { ChainlitContext, useAuth } from '@chainlit/react-client';

import './index.css';

import { i18nSetupLocalization } from './i18n';
import { datadogRum } from '@datadog/browser-rum';

i18nSetupLocalization();
const mode = import.meta.env.MODE;

// Initialize Datadog RUM outside of React component
if (mode === 'production') {
  datadogRum.init({
    applicationId: '7a72074f-bc81-45ec-95da-db5fe57a449f',
    clientToken: 'pub85a43600b3071df86d957cc3a29dbb53',
    site: 'datadoghq.com',
    service: 'askawatch',
    env: '<ENV_NAME>',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
} else if (mode === 'staging') {
  datadogRum.init({
    applicationId: '16019c12-b64b-41d9-a3de-52f64bbb6718',
    clientToken: 'pub53fa63cfdb3fe26779318e4862b0a4a1',
    site: 'datadoghq.com',
    service: 'askawatch',
    env: 'non-prod',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
} else {
  // datadogRum.init({
  //   applicationId: '16019c12-b64b-41d9-a3de-52f64bbb6718',
  //   clientToken: 'pub53fa63cfdb3fe26779318e4862b0a4a1',
  //   site: 'datadoghq.com',
  //   service: 'askawatch',
  //   env: 'non-prod',
  //   sessionSampleRate: 100,
  //   sessionReplaySampleRate: 20,
  //   trackBfcacheViews: true,
  //   defaultPrivacyLevel: 'mask-user-input',
  // });

  console.log('Product analytics disabled in development mode');
}

// ✅ NEW: Component to set Datadog user after authentication
function DatadogUserTracker() {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      const userEmail = (user?.metadata as any)?.email || '';
      const userName = (user?.metadata as any)?.full_name || '';
      const oid = (user?.metadata as any)?.oid || '';
      const userRole = (user?.metadata as any)?.role || '';

      datadogRum.setUser({
        id: oid,
        name: userName,
        email: userEmail,
        user_role: userRole,
      });
    }
  }, [user]);

  return null;
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ChainlitContext.Provider value={apiClient}>
      <RecoilRoot>
        <DatadogUserTracker />
        <AppWrapper />
      </RecoilRoot>
    </ChainlitContext.Provider>
  </React.StrictMode>
);
